<template>
    <v-container class="main-container">
      <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
      <v-container style="margin-top: 15px;">
        <v-row>
            <v-col cols="12" xl="6" class="text-h4">個人用印影一覧</v-col>
              <v-col cols="12" xl="6" class="text-right">
                  <v-btn color="orange" class="white--text" @click="clickAdd">追加</v-btn>
              </v-col>
        </v-row>
      </v-container>
      	
  <!-- 削除 -->
  <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-individual-imprints/'}" @success="getIndividuals" @error="error">
      <template v-slot:title>削除してよろしいですか？</template>
      <template v-slot:ok-btn>削除</template>
      <template v-slot:cancel-btn>キャンセル</template>
  </delete-dialog-component>
  
  <!-- 削除（デフォルト印影画像） -->
  <delete-dialog-component v-if="deleteDialog2" :deleteDialog.sync="deleteDialog2" :item="{id: currentItem, table: '/documents/delete-default-imprints/'}" @success="index" @error="error">
      <template v-slot:title>削除してよろしいですか？</template>
      <template v-slot:ok-btn>削除</template>
      <template v-slot:cancel-btn>キャンセル</template>
  </delete-dialog-component>

  <!-- グループ追加 -->
  <individualimprints-add-dialog-component v-if="addDialog" :addDialog.sync="addDialog" @success="getIndividuals">
      <template v-slot:cancel-btn>キャンセル</template>
      <template v-slot:ok-btn>登録</template>
  </individualimprints-add-dialog-component>

    <!-- 一覧表示 -->
    <v-row justify="center">
      <v-col
        cols="12"
      >  
        <v-simple-table class="pa-6">
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  名称
                </th>
                <th>
                  印影
                </th>
                <th>
                　操作ボタン
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(defaultImprint, idx) in defaults"
                :key="`first-${idx}`"
              >
                <td>{{ defaultImprint.imprint_name }}</td>
                <td>
                    <v-img
                        :src="defaultImprint.image_data"
                        max-height="40"
                        max-width="40"
                        width="40"
                        height="40"
                        :contain="true"
                    >
                    </v-img>

                </td>
                <td>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="clickDelete2(defaultImprint.id)"
                  >
                  削除
                  </v-btn>
              　</td>
              </tr>
              <tr
                v-for="(individual, idx) in new_individuals"
                :key="`second-${idx}`"
              >
                <td>{{ individual.imprint_name }}</td>
                <td>
                    <v-img
                        :src="individual.image_data"
                        max-height="40"
                        max-width="40"
                        width="40"
                        height="40"
                        :contain="true"
                    >
                    </v-img>
                
                </td>
                <td>
                  <v-spacer></v-spacer>
                  <v-btn 
                    color="blue-grey"
                    class="white--text"
                    @click="clickDelete(individual)"
                  >
                  削除
                  </v-btn>
              　</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    props: {
        individuals: {
          type: Array,
          required: true
        },
        // デフォルト印影画像
        defaults: {
          type: Array,
        },
    }, 
    data() {
        return {
            addDialog: false,
            new_individuals: this.individuals,
            // 削除 開閉フラグ
            deleteDialog: false,
            deleteDialog2: false,
            // メッセージ
            message: null,
            success: false,            
        };
    },
    methods: {
        getIndividuals(message) {
            axios
                .get("/documents/get-individuals")
                .then(response => {
                    this.new_individuals = response.data.individuals;
                    this.success = true;
                    this.message = message;                    
                })
                .catch(err => {
                    this.success = false;
                    this.message = err;
                });
        },
        // 削除ボタン押下
        clickDelete(item) {
            this.deleteDialog = true;
            this.currentItem = item;
        },
        // 削除ボタン押下（デフォルト印影画像）
        clickDelete2(item) {
            this.deleteDialog2 = true;
            this.currentItem = item;
        },
        // デフォルト印影画像削除後、初期画面へ戻る
        index(message) {
          this.success = true;
          this.message = message;
          window.location = "/documents/individual-electronic-imprints";
        },
        // エラー
        error(message) {
            this.success = false;
            this.message = message;
        },
        // 追加ボタン押下
        clickAdd() {
            this.addDialog = true;
        },
    },    
    computed: {
        // メッセージ
        isMessage: {
            get() {
                return this.message != null;
            },
            set(value) {
                if (!value) {
                    this.message = null;
                }
            }
        },
    },
};
</script>

<style scoped>
  ::v-deep td {
    padding: 5px 0!important;
  }
</style>
